const title = "Audit log";

const entryDialog = {
	title: "Audit log entry",
};
const table = {
	export: { csv: "Export CSV" },
	headers: {
		created_at: "Created at",
		debtor_code: "Debtor code",
		entry: "Entry",
		event: "Event",
		ip_address: "IP-address",
		username: "Username",
	},
};

const audit_log = {
	entry_dialog: entryDialog,
	table: table,
	title: title,
};

export default audit_log;
